import { TActionButtonV2 } from './actionButtonV2';
import { TActionButtonV3 } from './actionButtonV3';
import { TTypeChatbot, IChatbotMessageSchema } from './chatbot';
import { TMessageBubble } from './messageBubble';
import { TMessageFiles } from './messageFiles';
import { IMessageInChatListSchema } from '../repositories/chats/entities/chat/MessageInChatListSchema';
import { IOfferForClientSchema } from '../repositories/chats/entities/for_client/OfferForClientSchema';
import {
  TType,
  TStatus,
  IMessageListItemV2Schema,
} from '../repositories/chats/entities/message_list_item_v2/MessageListItemV2Schema';
import { IErrorResponseSchema } from '../repositories/chats/entities/schemas/ErrorResponseSchema';

import type { IMessageAssumptionsSchema } from '../repositories/chats/entities/check_message/MessageAssumptionsSchema';

type TMessageType = TType | TTypeChatbot;

type TMessageSchema = Omit<IMessageListItemV2Schema, 'type' | 'status'> &
  Omit<IChatbotMessageSchema, 'fromChatBot' | 'canBeDeleted' | 'fromCrm' | 'type' | 'status'> & {
    fromChatBot?: boolean;
    rowVersionV2?: string;
    canBeDeleted?: boolean;
    fromCrm?: boolean;
    type: TMessageType;
    status: TStatus;
    unread: boolean;
  };

enum EOutcomingStatus {
  Pending = 'pending',
  Failed = 'failed',
  Fulfilled = 'fulfilled',
  Read = 'read',
}
// TODO - перейти на один тип (в циан-помошнике сейчас используется number)
type TRowVersion = number | string;

type TOutcomingStatus = `${EOutcomingStatus}`;

type TBaseMessage = {
  created: number;
  message: string;
  htmlText?: string | null;
  userId: number;
  actionButtons?: TActionButtonV2[];
  actionButtonsV3?: TActionButtonV3[];
  files?: TMessageFiles;
  isRead?: boolean;
  assumptions?: IMessageAssumptionsSchema;
  offers?: IOfferForClientSchema[];
  bubbles?: TMessageBubble[];
  type?: TMessageType;
  isOutcoming: boolean;
  rowVersion?: TRowVersion;
  images?: string[];
  fromCrm?: boolean;
  fromChatBot?: boolean;
  communicationId?: string;
  animation?: boolean;
};

type TIncomingMessage = TBaseMessage & {
  isRead: boolean;
};

type TOutcomingMessage = TBaseMessage & {
  status: TOutcomingStatus;
};

type TMessage = TIncomingMessage | TOutcomingMessage;

export {
  type TTypeChatbot,
  type TType as TMessageType,
  type TStatus as TStatusMessage,
  IMessageAssumptionsSchema,
  EOutcomingStatus,
};
export type {
  IMessageListItemV2Schema as TMessageListItemV2,
  IErrorResponseSchema as TMessagesResponseError,
  TMessage,
  TMessageSchema,
  TOutcomingStatus,
  IMessageInChatListSchema as TLastMessageInChatList,
  TRowVersion,
};
